import { render, staticRenderFns } from "./MyGroupCard.vue?vue&type=template&id=34245ea1&scoped=true&"
import script from "./MyGroupCard.vue?vue&type=script&lang=js&"
export * from "./MyGroupCard.vue?vue&type=script&lang=js&"
import style0 from "./MyGroupCard.vue?vue&type=style&index=0&id=34245ea1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34245ea1",
  null
  
)

export default component.exports